var _path, _line, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinepicPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 161,
    viewBox: "0 0 9 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 161C6.209 161 8 159.209 8 157C8 154.791 6.209 153 4 153C1.791 153 0 154.791 0 157C0 159.209 1.791 161 4 161Z",
    fill: "#818181"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.74998,
    y1: 13.0056,
    x2: 3.74998,
    y2: 147.006,
    stroke: "#818181",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C8.5 5.93286 6.93286 7.5 5 7.5C3.06714 7.5 1.5 5.93286 1.5 4C1.5 2.06714 3.06714 0.5 5 0.5C6.93286 0.5 8.5 2.06714 8.5 4Z",
    stroke: "#818181"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinepicPayment);
export default __webpack_public_path__ + "static/media/linepic-payment.52c8d5c86753deb0d1ff2f6b1a87a6a0.svg";
export { ForwardRef as ReactComponent };